/* eslint-disable @typescript-eslint/member-ordering */
enum DataTypeStrings {
  Object = '[object Object]',
  Array = '[object Array]',
}

export default class DataTypeUtils {
  private static toString(data: any): string {
    return Object.prototype.toString.call(data);
  }

  public static isArray(data: any): boolean {
    return DataTypeUtils.toString(data) === DataTypeStrings.Array;
  }

  public static isObject(data: any): boolean {
    return DataTypeUtils.toString(data) === DataTypeStrings.Object;
  }

  public static isFunction(v: any) {
    return typeof v === 'function';
  }
}
